export const FAQData = {
  birthdayHeroChallenge: [
    {
      id: "bhc-1",
      question: "What is Birthday Hero Challenge",
      answer:
        "It's a hunger cause advocacy campaign that rewards participants with a Gift Bonus Reward of $250 to enjoy Birthday gifts with no money out of their pocket to guarantee recurring donations to feed food-insecure families.",
    },
    {
      id: "bhc-2",
      question: "Do I need to pay any fees to participate?",
      answer: "You are not required to pay any Signup fees.",
    },
    {
      id: "bhc-3",
      question: "Who is eligible to participate in the challenge?",
      answer:
        "The Challenge participation is limited to +1 country code users only.",
    },
    {
      id: "bhc-4",
      question: "What do I require to participate in the challenge?",
      answer:
        "You are only required to have + 1 Country code phone number when creating your gift wallet to get credited with your gift bonus of $250.",
    },
  ],
  logStories: [
    {
      id: "ls-1",
      question: "What is a log story?",
      answer:
        "Log Story is a digital social calendar event medium that allows users to capture, preserve, and share their personal stories, memories, and experiences. The platform is designed to help individuals document their life events—whether big or small—in a simple, intuitive interface that facilitates storytelling.",
    },
    {
      id: "ls-2",
      question: "What kind of content can I add to a log story?",
      answer:
        "Users can create their own log stories in various formats, such as text and images, and organize them chronologically, creating a personal timeline of significant moments in their lives. The platform also provides social features, allowing users to share their stories with friends, or the wider community, making it a space for reflection, connection, and sharing.",
    },
    {
      id: "ls-3",
      question: "What are chats?",
      answer:
        "Chats are a form of user interaction, allowing users to have conversations about a particular log story.",
    },
    {
      id: "ls-4",
      question: "What are logs?",
      answer:
        "Logs are another form of user interaction, similar to likes in other social platforms, for users to express interest in a particular log story.",
    },
    {
      id: "ls-5",
      question: "Who can create log stories?",
      answer:
        "Any user, Cause Shopping Assistants and Cause Shoppers, will be able to create log stories.",
    },
    {
      id: "ls-6",
      question: "Who can repost a log story?",
      answer:
        "The owner of the log story is the only one who can create repost of their log stories.",
    },
    {
      id: "ls-7",
      question: "How are log stories created?",
      answer:
        "Log stories are created by clicking on the log story button at the top right of the screen, then selecting create new option. Users are then able to proceed with either suggested log stories or create their custom log stories.",
    },
    {
      id: "ls-8",
      question: "How do you repost a log story?",
      answer:
        "Log stories are reposted by clicking on the log story button at the top right of the screen, then selecting the repost option. You can then select from your log stories history, the log story that you want to repost.",
    },
    {
      id: "ls-9",
      question: "How are chats associated with log stories?",
      answer:
        "Chats are meant to be a medium for user interactions and expression regarding a particular log story.",
    },
    {
      id: "ls-10",
      question: "Why are log stories important?",
      answer:
        "Log stories are important since they offer a way for co-creators and other users to share and showcase impact while telling their personal stories.",
    },
    {
      id: "ls-11",
      question: "Where will my log stories be displayed after creation?",
      answer:
        "Log stories will be displayed in the log story tab of the home section",
    },
    {
      id: "ls-12",
      question: "Where are chats accessed from?",
      answer:
        "Chats are accessed through clicking the chats icon on the interactive bar below the log story image section.",
    },
    {
      id: "ls-13",
      question: "When can someone create a log story?",
      answer:
        "Users will be able to create log stories anytime they have a story to tell or an impact to showcase.",
    },
    {
      id: "ls-14",
      question: "When can someone repost a log story?",
      answer:
        "Users will be able to repost log stories anytime they need to add updates to their previously created stories.",
    },
  ],
  connect: [
    {
      id: "cn-1",
      question: "What is to 'connect'?",
      answer:
        "Connect is a peer-to-peer networking benefit, such that, one user sends a connection request, by attaching a connection value e.g., My friend, to another user, who must actively accept it to establish a mutual connection. You will also be able to connect with your favorite listed brands based on preferred connection value eg My Shoe Brand, My Clothing Brand etc. You will also be allowed to reject connection requests. Connecting is a way of extending a handshake but in a digital world.",
    },
    {
      id: "cn-2",
      question: "What are connection values?",
      answer:
        "A connection value is a personalized label or context that explains the reason for wanting to connect with someone. It provides insight into the intent behind the connection request. Examples of connection values are 'My friend', 'My colleague', 'My spouse' etc.",
    },
    {
      id: "cn-3",
      question: "Who initiates connection requests?",
      answer:
        "The user who wants to establish a connection initiates the connection request, alongside a connection value.",
    },
    {
      id: "cn-4",
      question: "How are connection requests made?",
      answer:
        "Connection requests are made by clicking on the connect button beside a user's profile name, then selecting from a list of suggested connection values, or creating a custom connection value, then clicking on send connection button to make the connection request.",
    },
    {
      id: "cn-5",
      question:
        "How will users know when a connection request is sent to them?",
      answer:
        "Users will be sent a notification when a connection request is sent to them, which they can view the request and accept or reject the connection value.",
    },
    {
      id: "cn-6",
      question: "Why are connections important?",
      answer:
        "Connections forge digital bonds by mimicking real-world social interactions, transforming the traditional handshake or friendly gesture into an online networking moment where users can intentionally build and expand their interpersonal networks.",
    },
    {
      id: "cn-7",
      question: "Where can someone initiate connections?",
      answer:
        "Connections are initiated by clicking on the connect button beside a user's profile name.",
    },
    {
      id: "cn-8",
      question: "Where can someone accept/reject a connection request?",
      answer:
        "A user can accept or reject a connection request from the notifications panel where the connection request message is viewed from.",
    },
    {
      id: "cn-9",
      question: "When can connection requests be made?",
      answer:
        "Connection requests can be made anytime, as long a user has logged into their account.",
    },
  ],
};
